/**
 * @desc Trigger a browser download for a URL without opening a new tab.
 *
 * The `download` attribute is only honoured for same-origin URLs, so for
 * cross-origin GCS signed URLs the actual download behaviour comes from the
 * response `Content-Disposition: attachment` header set when the signed URL is
 * generated. The attribute is kept as a best-effort filename hint for the
 * same-origin case.
 */
export function downloadFile(url: string, filename?: string): void {
  const a = document.createElement('a');
  a.href = url;
  if (filename) a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
}
